import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import reset_45category_45global from "/opt/buildhome/repo/middleware/reset-category.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  reset_45category_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}